/**
 * Removes empty strings from an object and returns a new object with the empty strings removed.
 * If setToNull is true, empty strings will be converted to null.
 * If setToNull is false, empty strings will be converted to undefined. All undefined values will be filtered out.
 * @param obj - The object to remove empty strings from.
 * @param setToNull - Whether to convert empty strings to null.
 * @returns A new object with the empty strings removed or converted to null.
 */
export const removeEmptyStrings = (obj: any, setToNull = false): any => {
  if (typeof obj !== 'object' || obj === null) {
    if (obj === '' && setToNull) {
      return null;
    }
    return obj === '' && !setToNull ? undefined : obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => removeEmptyStrings(item, setToNull)).filter((item) => item !== undefined);
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const cleanedValue = removeEmptyStrings(value, setToNull);

    if (cleanedValue === undefined && setToNull) {
      acc[key] = null;
    } else {
      acc[key] = cleanedValue;
    }

    return acc;
  }, {} as any);
};
